import { z } from "zod";

import { getNormalEnum } from "../pseudoEnums.js";

export const SqlCellActiveTabLiteral = z.enum(["display", "preview", "chart"]);
export type SqlCellActiveTab = z.infer<typeof SqlCellActiveTabLiteral>;
export const SqlCellActiveTab = getNormalEnum(SqlCellActiveTabLiteral);
